import { FormikRadioGroup } from '@festina-life/ui/formikForms'
import { useTranslate } from '@festina-life/ui/hooks'

import { validate } from './helpers'

export const DataIngestionQuestionStep = () => {
  const translate = useTranslate()

  return (
    <FormikRadioGroup
      label={translate(
        'branchCreationWizard.dataIngestionQuestion.description',
      )}
      options={[true, false]}
      renderFn={(value) =>
        value
          ? translate('branchCreationWizard.dataIngestionQuestion.yes')
          : translate('branchCreationWizard.dataIngestionQuestion.no')
      }
      name={validate('shouldAddData')}
    />
  )
}
